<template>
  <QuillEditor
    ref="quillEditor"
    v-model:content="contentValue"
    theme="snow"
    class="z-editor"
    toolbar="essential"
    :content-type="contentType"
    @update:content="change"
    @textChange="onTextChange"
    @blur="onblur"
  />
</template>
<script>
import { QuillEditor } from '@vueup/vue-quill'
export default {
  name: 'ZEditor',
  components: {
    QuillEditor
  },
  props: {
    modelValue: String,
    contentType: {
      type: String,
      default: 'delta'
    }
  },
  emits: ['blur', 'update:modelValue', 'change', 'message'],
  computed: {
    contentValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    change(content) {
      this.$emit('update:modelValue', content)
    },
    onTextChange() {
      this.$emit('change', event)
    },
    onblur(event) {
      this.$emit('blur', event)
    },
    insertText(text) {
      var quill = this.$refs.quillEditor.getQuill()
      var range = quill.getSelection()
      if (range) {
        if (range.length == 0) {
          console.log('User cursor is at index', range.index)
        } else {
          var highlight = quill.getText(range.index, range.length)
          console.log('User has highlighted: ', highlight)
        }
        quill.insertText(range.index, text)
      } else {
        let msg = 'First place your cursor in the editor.'
        this.$emit('message', msg)
        console.log(msg)
      }
    },
    getText() {
      return this.$refs.quillEditor.getText()
    },
    getHTML() {
      var quill = this.$refs.quillEditor.getQuill()
      var results = quill.container.firstChild.innerHTML
      // var results = quill.getHTML()
      return results
    },
    setHTML(contents) {
      var quill = this.$refs.quillEditor.getQuill()
      quill.container.firstChild.innerHTML = contents
    }
  }
}
</script>
<style scoped></style>
